import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgAddDocumentDropzoneIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 13,
	viewBox: "0 0 13 13",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M7.00391 5.46092H12.1953V6.77342H7.00391V12.0866H5.58594V6.77342H0.5V5.46092H5.58594V0.333313H7.00391V5.46092Z",
		fill: "#666666"
	})]
});
const ForwardRef = forwardRef(SvgAddDocumentDropzoneIcon);
export default ForwardRef;
